import React from "react";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const Sports: React.FC<Props> = ({ formData, onChange }) => {

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <h4>Primary Sport Details</h4>
                                <div className="col-lg-4">
                                    <label className="form-label">Primary Sport</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="primarySport"
                                        required
                                        value={formData.primarySport}
                                        onChange={onChange}
                                        placeholder="Enter Primary Sport" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Present Coach</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="presentCoach"
                                        required
                                        value={formData.presentCoach}
                                        onChange={onChange}
                                        placeholder="Enter Present Coach" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Training Center Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="trainingCenterName"
                                        required
                                        value={formData.trainingCenterName}
                                        onChange={onChange}
                                        placeholder="Enter Training Center Name" />
                                </div>
                                <h4 className="mt-2">Secondary Sport Details</h4>
                                <div className="col-lg-4">
                                    <label className="form-label">Secondary Sport</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="secondarySport"
                                        required
                                        value={formData.secondarySport}
                                        onChange={onChange}
                                        placeholder="Enter Secondary Sport" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Secondary Sport Present Coach</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="secondarySportPresentCoach"
                                        required
                                        value={formData.secondarySportPresentCoach}
                                        onChange={onChange}
                                        placeholder="Enter Secondary Sport Present Coach" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Secondary Sport Training Center Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="secondarySportTrainingCenterName"
                                        required
                                        value={formData.secondarySportTrainingCenterName}
                                        onChange={onChange}
                                        placeholder="Enter Secondary Sport Center" />
                                </div>
                                <h4 className="mt-2">Tertiary Sport Details</h4>
                                <div className="col-lg-4">
                                    <label className="form-label">Tertiary Sport</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="tertiarySport"
                                        required
                                        value={formData.tertiarySport}
                                        onChange={onChange}
                                        placeholder="Enter Tertiary Sport" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Tertiary Sport Present Coach</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="tertiarySportPresentCoach"
                                        required
                                        value={formData.tertiarySportPresentCoach}
                                        onChange={onChange}
                                        placeholder="Enter Tertiary Sport Present Coach" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Tertiary Sport Training CenterName</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="tertiarySportTrainingCenterName"
                                        required
                                        value={formData.tertiarySportTrainingCenterName}
                                        onChange={onChange}
                                        placeholder="Enter Tertiary Sport Center" />
                                </div>
                                <h4 className="mt-2">Athlete Profile Details</h4>
                                <div className="col-lg-4">
                                    <label className="form-label">Dominant Side</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dominantSide"
                                        required
                                        value={formData.dominantSide}
                                        onChange={onChange}
                                        placeholder="Enter Dominant Sport" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Player Position</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="playerPosition"
                                        required
                                        value={formData.playerPosition}
                                        onChange={onChange}
                                        placeholder="Enter Player Position" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Current Competition Level</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="currentCompetitionLevel"
                                        required
                                        value={formData.currentCompetitionLevel}
                                        onChange={onChange}
                                        placeholder="Enter Current Competition Level" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sports;